const chip = (name, color = "bg-cyan-200", textColor = "text-cyan-900") => ({
  name,
  color,
  textColor,
  darkBgColor: "dark:bg-cyan-700",
  darkTextColor: "dark:text-cyan-100",
});

const projects = [
  {
    title: "E-commerce Web QA - Day-Sales",
    description:
      "QA case study for a multi-device e-commerce and sales platform. I tested critical user journeys from product browsing to cart, checkout, order detail, and responsive display states.",
    highlights: [
      "Designed manual test cases from business requirements and UI flows.",
      "Validated positive, negative, boundary, and regression scenarios.",
      "Reported reproducible UI/API defects with expected result, actual result, severity, and evidence.",
      "Used frontend knowledge to inspect responsive issues, browser behavior, and data-driven states faster.",
    ],
    technologies: [
      chip("Manual Testing", "bg-emerald-200", "text-emerald-900"),
      chip("Test Cases", "bg-cyan-200", "text-cyan-900"),
      chip("Regression", "bg-indigo-200", "text-indigo-900"),
      chip("Jira", "bg-blue-200", "text-blue-900"),
      chip("Vue.js", "bg-yellow-200", "text-yellow-900"),
      chip("REST APIs", "bg-sky-200", "text-sky-900"),
    ],
    artifacts: [
      {
        label: "Sample Test Plan",
        href: "https://github.com/huypv2002/PVHuyPortfolio",
      },
      {
        label: "Sample Test Cases",
        href: "https://github.com/huypv2002/PVHuyPortfolio",
      },
    ],
    liveLink: "https://sieuthi.goollow.org/",
    img: [
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740739411/Screenshot_2_rvc7jg.png",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740739477/Screenshot_3_iafozr.png",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740739516/Screenshot_4_ulqnpx.png",
    ],
  },
  {
    title: "Frontend Quality Review - Urban Building Landing Page",
    description:
      "Quality review and testing work for a responsive game landing page. The focus was UI consistency, mobile layout, navigation behavior, content rendering, and release confidence before publishing.",
    highlights: [
      "Checked responsive behavior across desktop and mobile breakpoints.",
      "Verified content, links, images, CTA behavior, and visual consistency.",
      "Used frontend experience to identify layout risks and browser-specific UI issues.",
    ],
    technologies: [
      chip("UI Testing", "bg-purple-200", "text-purple-900"),
      chip("Responsive QA", "bg-pink-200", "text-pink-900"),
      chip("Cross-browser", "bg-slate-200", "text-slate-900"),
      chip("HTML/CSS", "bg-orange-200", "text-orange-900"),
      chip("JavaScript", "bg-blue-200", "text-blue-900"),
    ],
    liveLink: "https://urbanbuilding.dthopenideas.com/",
    img: [
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740976978/Screenshot_10_yq9ciu.png",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740976978/Screenshot_12_uoe4no.png",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740976977/Screenshot_13_okiokw.png",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740976977/Screenshot_14_agg8ya.png",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740976977/Screenshot_15_kozngp.png",
    ],
  },
  {
    title: "Company Website QA - Open Ideas",
    description:
      "Manual QA and frontend validation for a corporate website that presents multiple products. The main goal was to protect content quality, link accuracy, responsive rendering, and smooth user navigation.",
    highlights: [
      "Reviewed navigation, page sections, product links, and content accuracy.",
      "Checked layout stability on different screen sizes.",
      "Validated UI changes after fixes to reduce regression risk.",
    ],
    technologies: [
      chip("Manual QA", "bg-emerald-200", "text-emerald-900"),
      chip("Content QA", "bg-cyan-200", "text-cyan-900"),
      chip("Regression", "bg-indigo-200", "text-indigo-900"),
      chip("JavaScript", "bg-blue-200", "text-blue-900"),
      chip("HTML/CSS", "bg-orange-200", "text-orange-900"),
    ],
    liveLink: "https://dthopenideas.com/",
    img: [
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740976822/Screenshot_9_vtfkko.png",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740976822/Screenshot_6_rgdgqg.png",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740976822/Screenshot_8_z0piup.png",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740976822/Screenshot_7_opoo5u.png",
    ],
  },
  {
    title: "Game App QA Support - Urban Building: Fortune Quest",
    description:
      "Product quality support for a mobile game experience, combining UI implementation awareness with usability testing, visual checks, and interaction validation.",
    highlights: [
      "Validated UI states and interaction feedback in gameplay-facing screens.",
      "Checked screen-size behavior and visual consistency.",
      "Collaborated with product and development teammates to reproduce issues and confirm fixes.",
    ],
    technologies: [
      chip("Usability Testing", "bg-purple-200", "text-purple-900"),
      chip("Mobile QA", "bg-pink-200", "text-pink-900"),
      chip("Exploratory QA", "bg-teal-200", "text-teal-900"),
      chip("C#", "bg-blue-200", "text-blue-900"),
      chip("REST APIs", "bg-sky-200", "text-sky-900"),
    ],
    liveLink:
      "https://play.google.com/store/apps/details?id=com.openideas.urbanbuilding",
    githubLink:
      "https://apps.apple.com/vn/app/urban-building-fortune-quest/id6547839861",
    img: [
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740977506/unnamed_2_b8k8yp.webp",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740977506/unnamed_nqywr1.webp",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740977506/unnamed_1_qishvv.webp",
      "https://res.cloudinary.com/deuwp7fvq/image/upload/v1740977506/unnamed_3_jold66.webp",
    ],
  },
];

export default projects;
